import { IDeviceFullInfoContext } from './deviceFullInfoContext';

export enum DeviceFullInfoActionTypes {
	SET_DEVICE_FOR_FULL_INFO = 'SET_DEVICE_FOR_FULL_INFO',
	SET_DROPBOX_PUSH_FILE_TYPE = 'SET_DROPBOX_PUSH_FILE_TYPE',
	SET_DROPBOX_PUSH_MESSAGE = 'SET_DROPBOX_PUSH_MESSAGE',
	CHANGE_DROPBOX_PUSH_PARAMS = 'CHANGE_DROPBOX_PUSH_PARAMS',
	RESET_DROPBOX_PUSH_FIELDS = 'RESET_DROPBOX_PUSH_FIELDS',
	RESET_MODAL_STATE = 'RESET_MODAL_STATE',
	SET_DATA_FOR_PUSH = 'SET_DATA_FOR_PUSH',
	SWITCH_BACKUP_ENABLED = 'SWITCH_BACKUP_ENABLED',
	SET_DEACTIVATE_DEVICE_WITH_REMOVE_CONTENT = 'SET_DEACTIVATE_DEVICE_WITH_REMOVE_CONTENT',
	SET_DEACTIVATE_DEVICE_WITH_RESET_RESTAURANT = 'SET_DEACTIVATE_DEVICE_WITH_RESET_RESTAURANT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface ISetDeviceForFullInfo {
	type: DeviceFullInfoActionTypes.SET_DEVICE_FOR_FULL_INFO;
	payload: {
		deviceForFullInfo: IDeviceFullInfoContext['deviceForFullInfo'];
	};
}

interface ISetDropboxPushFileType {
	type: DeviceFullInfoActionTypes.SET_DROPBOX_PUSH_FILE_TYPE;
	payload: {
		selectedDropboxPushFileType: IDeviceFullInfoContext['selectedDropboxPushFileType'];
	};
}

interface ISetDropboxPushMessage {
	type: DeviceFullInfoActionTypes.SET_DROPBOX_PUSH_MESSAGE;
	payload: {
		selectedDropboxPushMessage: IDeviceFullInfoContext['selectedDropboxPushMessage'];
	};
}

interface IChangeDropboxPushParams {
	type: DeviceFullInfoActionTypes.CHANGE_DROPBOX_PUSH_PARAMS;
	payload: {
		dropboxPushParams: IDeviceFullInfoContext['dropboxPushParams'];
	};
}

interface IResetDropboxPushFields {
	type: DeviceFullInfoActionTypes.RESET_DROPBOX_PUSH_FIELDS;
}

interface IResetModalState {
	type: DeviceFullInfoActionTypes.RESET_MODAL_STATE;
}

interface ISetDataForPush {
	type: DeviceFullInfoActionTypes.SET_DATA_FOR_PUSH;
	payload: {
		dataForPush: IDeviceFullInfoContext['dataForPush'];
	};
}

interface ISwitchDevicesBackupEnabled {
	type: DeviceFullInfoActionTypes.SWITCH_BACKUP_ENABLED;
	payload: {
		isBackupEnabled: IDeviceFullInfoContext['isBackupEnabled'];
		isDeactivateDeviceWithRemoveContent: IDeviceFullInfoContext['isDeactivateDeviceWithRemoveContent'];
		isDeactivateDeviceWithResetRestaurant: IDeviceFullInfoContext['isDeactivateDeviceWithResetRestaurant'];
	};
}

interface ISetDeactivateDeviceWithRemoveContent {
	type: DeviceFullInfoActionTypes.SET_DEACTIVATE_DEVICE_WITH_REMOVE_CONTENT;
	payload: {
		isDeactivateDeviceWithRemoveContent: IDeviceFullInfoContext['isDeactivateDeviceWithRemoveContent'];
	};
}

interface ISetDeactivateDeviceWithResetRestaurant {
	type: DeviceFullInfoActionTypes.SET_DEACTIVATE_DEVICE_WITH_RESET_RESTAURANT;
	payload: {
		isDeactivateDeviceWithResetRestaurant: IDeviceFullInfoContext['isDeactivateDeviceWithResetRestaurant'];
	};
}

interface IChangeTypeOfModalWindow {
	type: DeviceFullInfoActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IDeviceFullInfoContext['typeOfModalWindow'];
	};
}

export type TDeviceFullInfoAction =
	| ISetDeviceForFullInfo
	| ISetDropboxPushFileType
	| ISetDropboxPushMessage
	| IChangeDropboxPushParams
	| IResetDropboxPushFields
	| IResetModalState
	| ISetDataForPush
	| ISwitchDevicesBackupEnabled
	| ISetDeactivateDeviceWithRemoveContent
	| ISetDeactivateDeviceWithResetRestaurant
	| IChangeTypeOfModalWindow;
